module.exports = __webpack_public_path__ + "front/img/bmbg02.2f90cea8.png";